import React from "react"
import Container from "react-bootstrap/Container"
import NavigationBar from "./NavigationBar"
import Footer from "./Footer"
import "fontsource-josefin-sans"
import "fontsource-black-ops-one"
import "./styles/index.scss"

const Layout = ({ children }) => {
  return (
    <Container className="bootstrap-container topContainer mx-auto px-0" fluid>
      <NavigationBar />
      {children}
      <Footer />
    </Container>
  )
}

export default Layout
